export const quillWrapperCssLoadingClass = 'quill-wrapper-css-loading';
